import { render, staticRenderFns } from "./Action.vue?vue&type=template&id=40b2f5e1"
import script from "./Action.js?vue&type=script&lang=js&external"
export * from "./Action.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports